module.exports = __webpack_public_path__ + "img/brochure_CR-mockup1.2dba0f13.jpg";